import React from "react";
import styled from "styled-components";

const TextBlock = styled.div`
  color: #adcae6;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  height: calc(100vh - 70px);
  @media only screen and (min-width: 768px) {
    height: calc(667px - 70px);
  }
  padding: 20px;
  h1 {
    font-size: 26px;
  }
  h2 {
    font-size: 20px;
  }
  p {
    font-size: 12px;
    line-height: 18px;
  }
`;

const PrivacyPolicy = () => {
  return (
    <TextBlock>
      <h1>Geordify Terms of Service and Privacy Policy</h1>
      <h2>1. Terms</h2>

      <p>
        By accessing the website at geordify.com, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</p>

      <h2>2. Use License</h2>

      <p>Permission is granted to temporarily download one copy of the materials (information or software) on Geordify's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
      modify or copy the materials;
      use the materials for any commercial purpose, or for any public display (commercial or non-commercial);
      attempt to decompile or reverse engineer any software contained on Geordify's website;
      remove any copyright or other proprietary notations from the materials; or
      transfer the materials to another person or "mirror" the materials on any other server.
      This license shall automatically terminate if you violate any of these restrictions and may be terminated by Geordify at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</p>

      <h2>3. Disclaimer</h2>

      <p>The materials on Geordify's website are provided on an 'as is' basis. Geordify makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
      Further, Geordify does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</p>

      <h2>4. Limitations</h2>

      <p>In no event shall Geordify or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Geordify's website, even if Geordify or a Geordify authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>

      <h2>5. Accuracy of materials</h2>

      <p>The materials appearing on Geordify's website could include technical, typographical, or photographic errors. Geordify does not warrant that any of the materials on its website are accurate, complete or current. Geordify may make changes to the materials contained on its website at any time without notice. However Geordify does not make any commitment to update the materials.</p>

      <h2>6. Links</h2>

      <p>Geordify has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Geordify of the site. Use of any such linked website is at the user's own risk.</p>

      <h2>7. Modifications</h2>

      <p>Geordify may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>

      <h2>8. Governing Law</h2>

      <p>These terms and conditions are governed by and construed in accordance with the laws of United Kingdom and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>

      <h2>Privacy Policy</h2>

      <p>Your privacy is important to us.</p>

      <p>It is Geordify's policy to respect your privacy regarding any information we may collect while operating our website. Accordingly, we have developed this privacy policy in order for you to understand how we collect, use, communicate, disclose and otherwise make use of personal information. We have outlined our privacy policy below.</p>

      <p>We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.
      Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.
      We will collect and use personal information solely for fulfilling those purposes specified by us and for other ancillary purposes, unless we obtain the consent of the individual concerned or as required by law.
      Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.
      We will protect personal information by using reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.
      We will make readily available to customers information about our policies and practices relating to the management of personal information.
      We will only retain personal information for as long as necessary for the fulfilment of those purposes.
      We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained. Geordify may change this privacy policy from time to time at Geordify's sole discretion.</p>
    </TextBlock>
  );
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.js